module.exports = __webpack_public_path__ + "h5/img/offer_2021.15182997.png";